import React from 'react';
import './Gewichtsberechnung.css';
import Kulissengewichtberechnung from "./Kulissengewichtberechnung.jsx";
import Lueftungsgehaeusegewichtberechnung from "./Lueftungsgehaeusegewichtberechnung.jsx";
import Rahmenprofilgewichtberechnung from "./Rahmenprofilgewichtberechnung";
import { calculateGesamtgewicht } from '../calculations/weight';

class Gewichtsberechnung extends React.Component {
  constructor(props) {
      super(props);
      this.handleLuftungsgehausegewichtChange = this.handleLuftungsgehausegewichtChange.bind(this);
      this.handleRahmenprofilgewichtEingangChange = this.handleRahmenprofilgewichtEingangChange.bind(this);
      this.handleRahmenprofilgewichtAusgangChange = this.handleRahmenprofilgewichtAusgangChange.bind(this);
      this.handlekulissengewichtChange = this.handlekulissengewichtChange.bind(this);

      this.state = {
          lueftungsgehausegewicht: null,
          rahmenprofilgewichtEingang: null,
          rahmenprofilgewichtAusgang: null,
          kulissengewicht: null,
      };
  }

    handleLuftungsgehausegewichtChange(e) {

        if(e !== this.state.lueftungsgehausegewicht){
            this.setState({lueftungsgehausegewicht: e});
        };
    }
    handlekulissengewichtChange(e) {

        if(e !== this.state.kulissengewicht){
            this.setState({kulissengewicht: e});
        };
    }
    handleRahmenprofilgewichtEingangChange(e){

        if(e !== this.state.rahmenprofilgewichtEingang){
            this.setState({rahmenprofilgewichtEingang: e});
        };
    }
    handleRahmenprofilgewichtAusgangChange(e){

        if(e !== this.state.rahmenprofilgewichtAusgang){
            this.setState({rahmenprofilgewichtAusgang: e});
        };
    }

  _gewichtsberechnung(){
      //let schalldaempferbreite = this.props.Schalldaempferbreite;
  }

  render() {
      // console.log("Props-Kulissenbreite: " + this.props.Kulissenbreite);
      // console.log("Props-Kulissenhoehe: " + this.props.Kulissenhoehe);
      // console.log("Props-Kulissenlaenge: " + this.props.Kulissenlaenge);
      // console.log("Props-Kulissenanzahl: " + this.props.Kulissenanzahl);
      // console.log("Props-Kulissentyp: " + this.props.Kulissentyp);
      // console.log("Props-Schalldaempferbreite: " + this.props.Schalldaempferbreite);
      // console.log("Props-Schalldaempferhoehe: " + this.props.Schalldaempferhoehe);
      // console.log("Props-Schalldaempferlaenge: " + this.props.Schalldaempferlaenge);
      // console.log("Props-Druckstufe: " + this.props.Druckbereich);
      //
      //
      // console.log("State-Lueftungsgehaeusegewicht: " + this.state.lueftungsgehausegewicht);
      // console.log("State-Kulissengewicht: " + this.state.lueftungsgehausegewicht); //Gewicht einer Kulisse
      // console.log("State-rahmenprofilgewicht Eingang: " + this.state.rahmenprofilgewichtEingang);
      // console.log("State-rahmenprofilgewicht Ausgang: " + this.state.rahmenprofilgewichtAusgang);



      return( <>

                    <Lueftungsgehaeusegewichtberechnung Lueftungskanalbreite={this.props.Schalldaempferbreite}
                                             Lueftungskanellaenge={this.props.Schalldaempferlaenge}
                                             Lueftungskanalhoehe={this.props.Schalldaempferhoehe}
                                             Kulissentyp={this.props.Kulissentyp}
                                             Druckbereich={this.props.Druckbereich} handleLuftungsgehausegewichtChange={this.handleLuftungsgehausegewichtChange} Hidden />


                    <Kulissengewichtberechnung  Kulissenbreite={this.props.Kulissenbreite} Kulissenlaenge={this.props.Kulissenlaenge}  Kulissenhoehe={this.props.Kulissenhoehe} Kulissentyp={this.props.Kulissentyp} handlekulissengewichtChange={this.handlekulissengewichtChange} Hidden />



                    <Rahmenprofilgewichtberechnung Lueftungskanalbreite={this.props.Schalldaempferbreite}
                                             Lueftungskanellaenge={this.props.Schalldaempferlaenge}
                                             Lueftungskanalhoehe={this.props.Schalldaempferhoehe}
                                             Kulissentyp={this.props.Kulissentyp}
                                             Druckbereich={this.props.Druckbereich}
                                             SelectedAnschlussprofil={this.props.SelectedAnschlussprofil}
                                             CalculatedAnschlussprofil={this.props.CalculatedAnschlussprofil}
                                             CheckedAnschlussprofil={this.props.CheckedAnschlussprofil}
                                                   handleRahmenprofilgewichtChange={this.handleRahmenprofilgewichtEingangChange} Hidden />



                    <Rahmenprofilgewichtberechnung Lueftungskanalbreite={this.props.Schalldaempferbreite}
                                             Lueftungskanellaenge={this.props.Schalldaempferlaenge}
                                             Lueftungskanalhoehe={this.props.Schalldaempferhoehe}
                                             Kulissentyp={this.props.Kulissentyp}
                                             Druckbereich={this.props.Druckbereich}
                                             SelectedAnschlussprofil={this.props.SelectedAnschlussprofil}
                                             CalculatedAnschlussprofil={this.props.CalculatedAnschlussprofil}
                                             CheckedAnschlussprofil={this.props.CheckedAnschlussprofil}
                                                   handleRahmenprofilgewichtChange={this.handleRahmenprofilgewichtAusgangChange} Hidden />



                {calculateGesamtgewicht(this.props).toFixed(0)}

      </>
      );
  }
}
export default Gewichtsberechnung;
// <Kulissengewichtberechnung  Kulissenbreite={this.props.Kulissenbreite} Kulissenlaenge={this.props.Kulissenlaenge}  Kulissenhoehe={this.props.Kulissenhoehe} Kulissentyp={"HKR"} />
// <Lueftungsgehausegewichtberechnung  Lueftungskanalbreite={this.props.Schalldaempferbreite}
//                                              Lueftungskanellaenge={this.props.Schalldaempferlaenge}
//                                              Lueftungskanalhoehe={this.props.Schalldaempferhoehe}
//                                              Kulissentyp={"HKR"}
//                                              Druckbereich={"ND"} />

//<Lueftungsgehaeusegewichtberechnung Lueftungskanalbreite={400}
//                                              Lueftungskanellaenge={200}
//                                              Lueftungskanalhoehe={6000}
//                                              Kulissentyp={"HKR"}
//                                              Druckbereich={"ND"} handleLuftungsgehausegewichtChange={this.handleLuftungsgehausegewichtChange}/>
